import React, { Component, Fragment } from 'react';

class PropertyActions extends Component {
  constructor(props) {
    super(props);
    this.state = { dropdownOpen: false };
  }

  // ----------------------
  // State setters
  // ----------------------

  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  render() {
    return (
      <Fragment>
        {this.props.actions &&
          this.props.actions.map((action, index) => (
            <i
              role="link"
              tabIndex={index}
              className={`fa fa-${action.icon}`}
              key={index.toString()}
              onClick={this.props[action.handlerProp]}
            />
          ))}
      </Fragment>
    );
  }
}

export default PropertyActions;
